import { render, staticRenderFns } from "./PtLocksTable.vue?vue&type=template&id=1d9bf9e9&scoped=true&"
import script from "./PtLocksTable.vue?vue&type=script&lang=js&"
export * from "./PtLocksTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9bf9e9",
  null
  
)

export default component.exports